import { Component, Input, Inject } from '@angular/core';

import { SideEffect } from "../../../../common/models/flow.dto";
import { SideEffectData, SIDE_EFFECT_DATA_TOKEN } from "./models/types";

@Component({
    selector: 'side-effect-commit-docs',
    templateUrl: './side-effect-commit-docs.component.html',
    standalone: false
})
export class SideEffectCommitDocsComponent {
    _selectedSideEffect: SideEffect;
    _seConfiguration: any;

    get organizationSource(): string {
        return this.seConfiguration.organizationSource;
    }

    set organizationSource(value: string) {
        this.seConfiguration.organizationSource = value;
    }

    get organizationIdContext(): string {
        return this.seConfiguration.organizationIdContext;
    }

    set organizationIdContext(value: string) {
        this.seConfiguration.organizationIdContext = value;
    }

    get organizationNameContext(): string {
        return this.seConfiguration.organizationNameContext;
    }

    set organizationNameContext(value: string) {
        this.seConfiguration.organizationNameContext = value;
    }

    set seConfiguration(value: any) {
        this._seConfiguration = value;
    }
    get seConfiguration(): any {
        if (this._seConfiguration == null || this._seConfiguration === undefined) {
            this._seConfiguration = { organizationSource : "flowCreator", organizationIdContext: "", organizationNameContext: "" };
        } 
        return this._seConfiguration;
        
    }

    organizationOptions = [
        { id: "flowCreator", text: "Organization originating the flow" },
        { id: "context", text: "Context Location" }
    ]

    

    constructor(
        @Inject(SIDE_EFFECT_DATA_TOKEN) public data: SideEffectData
    ) {
        this.seConfiguration = data.configuration;
    }

}